import React, { useState } from "react";
import { useSelector } from "react-redux";
import WidgetCarouselCard from "../../features/widget/widgetCarouselCard/WidgetCarouselCard";
import ShortcutsPopup from "../../../../teacher/pages/home/shortcutsPopup/ShortcutsPopup";
import shortcutsImg from "../../../../assests/carouselWidget/shourtcuts.png";

const ShortcutCarouselWidget = () => {

    const { texts } = useSelector(state => state.translate);
    const [shortcutsPopupOpen, setShortcutsPopupOpen] = useState(false);

    const openShortcutsPopup = (e) => {
        e?.stopPropagation();
        setShortcutsPopupOpen(true);
    };

    return (
        <>
            <WidgetCarouselCard
                color="#F6F6F6"
                title={texts.Shortcuts}
                image={shortcutsImg}
                imageAlt={texts.Shortcuts}
                onClick={openShortcutsPopup}
            />
            {shortcutsPopupOpen && <ShortcutsPopup onClose={() => setShortcutsPopupOpen(false)} />}
        </>
    );
};

export default ShortcutCarouselWidget;
